<template>
  <v-form lazy-validation v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" sm="12" md="11" lg="11">
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Kasbon # <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="lastKasbonNumber"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Site</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  item-text="name"
                  return-object
                  :items="listSite"
                  multiple
                  v-model="form.sites"
                  :filter="filterObject"
                >
                  <template v-slot:item="data">
                    <v-list-item v-on="data.on">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Vendor</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                  :items="vendors"
                  item-text="supplier_name"
                  item-value="id"
                  return-object
                  v-model="vendor"
                  @change="onChangeVendor"
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>PO Vendor</v-subheader>
              </v-col>
              <v-col cols="7" sm="7" md="5" lg="5" class="py-0">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                  :items="purchaseOrders"
                  item-text="name"
                  return-object
                  v-model="purchaseOrderVendor"
                  :filter="filterObjectPo"
                  :disabled="!vendor"
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      <v-list-item-subtitle v-html="data.item.remark"></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="1" sm="1" md="1" lg="1" class="py-0">
                <v-btn
                  icon
                  color="primary"
                  @click="addPurchaseOrder"
                  :disabled="!purchaseOrderVendor"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="selectedPurchaseOrders.length > 0">
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0"></v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-chip
                  v-for="(po, idx) in selectedPurchaseOrders"
                  :key="idx"
                  close
                  class="mr-1 mb-1"
                  @click:close="removePurchaseOrder(idx)"
                  small
                  >{{ po.name }}</v-chip
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Name</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  :items="employees"
                  item-text="name"
                  return-object
                  background-color="white"
                  v-model="employee"
                  @change="onChangeEmployee"
                  :rules="[v => !!v || 'Name is required']"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Date</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-menu
                  v-model="menuDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="form.kasbonDate"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.kasbonDate"
                    :allowed-dates="getAllowedDates()"
                    @input="menuDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Payment<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-select
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.paymentMethod"
                  :items="listPaymentMethod"
                  :rules="[v => !!v || 'Payment is required']"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" v-if="form.paymentMethod === 'Transfer'">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Account Number</v-subheader>
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" class="py-0" v-if="!form.external">
                <!-- <v-select
                  flat
                  dense
                  outlined
                  background-color="white"
                  :items="listAccountNumber"
                  item-value="id"
                  item-text="accountNumber"
                  v-model="form.accountNumberId"
                >
                </v-select> -->
                <v-text-field
                  flat
                  dense
                  outlined
                  background-color="white"
                  v-model="form.bankAccountNumber"
                  :rules="[v => !!v || 'Account Number is required']"
                >
                </v-text-field>
              </v-col>
              <v-col cols="2" sm="2" md="3" lg="3" class="py-0">
                <v-checkbox
                  flat
                  dense
                  outlined
                  background-color="white"
                  v-model="form.external"
                  @change="onChangeExternal"
                  label="External"
                >
                </v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="form.external">
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Owner Name</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  dense
                  outlined
                  flat
                  background-color="white"
                  v-model="form.externalAccountNumber.ownerName"
                  :rules="[v => !!v || 'Owner Name is required']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Account Number</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  dense
                  outlined
                  flat
                  background-color="white"
                  v-model="form.externalAccountNumber.accountNumber"
                  :rules="[v => !!v || 'Account Number is required']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="6"
            v-if="form.paymentMethod === 'Transfer' && !form.external"
          >
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Owner Bank</v-subheader>
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="6" class="py-0">
                <v-text-field
                  flat
                  dense
                  outlined
                  background-color="white"
                  v-model="form.ownerBank"
                  :rules="[v => !!v || 'Owner Bank is required']"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="form.external">
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Bank</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-select
                  dense
                  outlined
                  flat
                  background-color="white"
                  v-model="bank"
                  @change="onChangeBank"
                  return-object
                  item-text="name"
                  :items="banks"
                  :rules="[v => !!v || 'Bank is required']"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Division</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  dense
                  outlined
                  flat
                  background-color="white"
                  v-model="form.division"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Currency</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-select
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.currency"
                  :items="dropDownCurrency"
                  :rules="[v => !!v || 'Currency is required']"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Remark</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-textarea
                  outlined
                  flat
                  rows="3"
                  background-color="white"
                  v-model="form.remark"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>No Old Kasbon</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.oldKasbon"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>WO#<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  :items="listWo"
                  item-text="id"
                  background-color="white"
                  v-model="wo"
                  @change="onChangeWo"
                  :filter="filterObjectWo"
                  return-object
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ data.item.id }} ( {{ woDate(data.item.tasks) }})</v-list-item-title
                      >
                      <v-list-item-subtitle>{{ woSite(data.item.tasks) }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ data.item.poNumber }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Tax Date</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-menu
                  v-model="menuTaxDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="form.taxDate"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.taxDate"
                    @input="menuTaxDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>DPP</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.dppAmount"
                  type="number"
                  persistent-hint
                  :hint="formatPrice(form.dppAmount)"
                  :rules="[v => v >= 0 || 'DPP must more than equal 0']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Tax Serial Number</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.taxSerialNumber"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-tabs vertical>
              <v-tab background-color="light-blue accent-3" dark class="px-0">
                <v-icon>
                  mdi-note-text
                </v-icon>
              </v-tab>
              <v-tab background-color="light-blue accent-3" dark class="px-0">
                <v-icon>
                  mdi-note-text
                </v-icon>
              </v-tab>
              <v-tab-item>
                <v-card flat class="px-2">
                  <v-row>
                    <v-col cols="12" sm="12" md="4" lg="4">
                      <v-autocomplete
                        outlined
                        flat
                        dense
                        background-color="white"
                        append-icon="mdi-magnify"
                        :items="listCategory"
                        item-text="category"
                        return-object
                        v-model="category"
                        @change="onChangeCategory"
                        label="Category"
                      >
                        <template v-slot:item="data">
                          <v-list-item v-on="data.on">
                            <v-list-item-content>
                              <v-list-item-title v-html="data.item.category"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4">
                      <v-autocomplete
                        outlined
                        flat
                        dense
                        background-color="white"
                        append-icon="mdi-magnify"
                        :items="listTemplate"
                        item-text="name"
                        return-object
                        v-model="template"
                        @change="onChangeTemplate"
                        label="Template"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="4"
                      lg="4"
                      align-self="start"
                      class="text-right pb-0"
                    >
                      <p class="headline font-italic">
                        Requirement <span class="red--text">*</span>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headers"
                        :items="items"
                        disable-pagination
                        hide-default-footer
                        @click:row="onClickRow"
                        item-key="index"
                      >
                        <template v-slot:item.no="{ index }">
                          {{ index + 1 }}
                        </template>
                        <template v-slot:item.amount="{ item }">
                          {{ formatPrice(item.amount) }}
                        </template>
                        <template v-slot:item.emoney="{ item }">
                          <v-checkbox v-model="item.emoney" dense disabled></v-checkbox>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat class="px-2">
                  <v-row>
                    <v-col cols="12" class="text-right pb-0">
                      <p class="headline font-italic">WO <span class="red--text">*</span></p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headersWo"
                        :items="form.wos"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:item.no="{ index }">
                          {{ index + 1 }}
                        </template>
                        <template v-slot:item.action="{ index }">
                          <v-btn icon @click="deleteWo(index)" color="red">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="2">
            <v-card outlined>
              <v-card-title class="py-0">Total Kasbon</v-card-title>
              <v-card-text class="text-right mt-3">
                <span>{{ formatPrice(totalAmount) }}</span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card outlined>
              <v-card-title class="py-0">Total PPH</v-card-title>
              <v-card-text class="text-right mt-3">
                <span>{{ formatPrice(pphAmount) }}</span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="1" lg="1" class="py-0">
        <v-row class="py-0">
          <v-col cols="12" class="mb-4 py-0">
            <v-btn color="primary" @click="submit">
              <v-icon large>
                mdi-content-save
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-kasbon
      :item="item"
      :index="index"
      :dialog="dialog"
      @close="close"
      @save="addItem"
      @deleteItem="deleteItem"
    ></dialog-kasbon>
    <v-dialog v-model="dialogAllowance" max-width="500" persistent>
      <v-card>
        <v-card-title
          :class="
            isOverLimit ? 'red white--text' : isWarning ? 'orange white--text' : 'blue white--text'
          "
        >
          <v-icon left color="white">{{
            isOverLimit ? "mdi-alert-circle" : isWarning ? "mdi-alert" : "mdi-information"
          }}</v-icon>
          {{ isOverLimit ? "Limit Habis" : isWarning ? "Peringatan" : "Informasi Allowance" }}
        </v-card-title>
        <v-card-text class="pt-4">
          <p>{{ allowanceMessage }}</p>
          <v-simple-table v-if="allowanceData" dense class="mt-2">
            <tbody>
              <tr>
                <td>Allowance Bulanan</td>
                <td class="text-right">Rp. {{ formatPrice(allowanceData.nominal) }}</td>
              </tr>
              <tr>
                <td>Terpakai</td>
                <td class="text-right">Rp. {{ formatPrice(allowanceData.actual) }}</td>
              </tr>
              <tr>
                <td><strong>Sisa</strong></td>
                <td
                  class="text-right"
                  :class="isOverLimit ? 'red--text' : isWarning ? 'orange--text' : 'green--text'"
                >
                  <strong>Rp. {{ formatPrice(allowanceData.remain) }}</strong>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogAllowance = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import DialogKasbon from "@/components/DialogKasbon";
import { fiscalMonthMixin } from "@/services/mixins/fiscalMonthMixin";

export default {
  name: "create-general-kasbon",
  mixins: [fiscalMonthMixin],
  components: {
    "dialog-kasbon": DialogKasbon,
  },
  data: () => ({
    defaultForm: {
      formNumber: "",
      kasbonDate: moment().format("yyyy-MM-DD"),
      employeeId: null,
      name: "",
      division: "",
      paymentMethod: "",
      remark: "",
      currency: "IDR",
      accountNumberId: null,
      bankAccountNumber: "",
      totalAmount: 0,
      kasbonNumber: null,
      oldKasbon: "",
      vendorId: null,
      vendorName: "",
      purchaseOrderNumber: "",
      items: [],
      sites: [],
      wos: [],
      status: "Outstanding",
      external: false,
      externalAccountNumber: null,
      ownerBank: "",
      taxDate: moment().format("yyyy-MM-DD"),
      dppAmount: 0,
      taxSerialNumber: "",
      pphAmount: 0,
    },
    menuDate: false,
    menuTaxDate: false,
    form: {},
    items: [],
    dialog: false,
    item: {},
    wo: {},
    index: -1,
    category: null,
    employee: null,
    vendor: null,
    purchaseOrders: [],
    purchaseOrderVendor: null,
    selectedPurchaseOrders: [],
    template: null,
    listCategory: [],
    listTemplate: [],
    listSite: [],
    listWo: [],
    valid: true,
    listPaymentMethod: ["Cash", "Transfer"],
    headers: [
      {
        text: "No",
        value: "no",
        sortable: false,
        divider: true,
      },
      {
        text: "Requirement",
        value: "category",
        sortable: false,
        divider: true,
      },
      {
        text: "Description",
        value: "description",
        sortable: false,
        divider: true,
      },
      {
        text: "Start Date",
        value: "startDate",
        sortable: false,
        divider: true,
      },
      {
        text: "End Date",
        value: "endDate",
        sortable: false,
        divider: true,
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false,
        divider: true,
      },
      {
        text: "eMoney",
        value: "emoney",
        sortable: false,
        divider: true,
      },
      {
        text: "Account Name",
        value: "accountName",
        sortable: false,
        divider: true,
      },
    ],
    headersWo: [
      {
        text: "No",
        value: "no",
        sortable: false,
        divider: true,
      },
      {
        text: "WO Number",
        value: "woId",
        sortable: false,
        divider: true,
      },
      {
        text: "Site",
        value: "sites",
        sortable: false,
        divider: true,
      },
      {
        text: "Date",
        value: "dates",
        sortable: false,
        divider: true,
      },
      {
        text: "PO#",
        value: "poNumber",
        sortable: false,
        divider: true,
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
        divider: true,
      },
    ],
    alert: false,
    banks: [],
    bank: null,
    dialogAllowance: false,
    allowanceMessage: "",
    isOverLimit: false,
    isWarning: false,
    allowanceData: null,
  }),

  computed: {
    totalAmount() {
      return this.items
        .filter(x => x.calculated)
        .map(x => x.amount)
        .reduce((a, b) => a + b, 0);
    },
    pphAmount() {
      return this.items
        .filter(x => !x.calculated)
        .map(x => x.amount)
        .reduce((a, b) => a + b, 0);
    },

    ...mapState("generalKasbon", ["lastFormNumber", "lastKasbonNumber", "listAccountNumber"]),
    ...mapState("currency", ["dropDownCurrency"]),
    ...mapState("external", ["employees", "vendors"]),
  },

  watch: {},

  methods: {
    async submit() {
      if (this.$refs.form.validate() && this.items.length > 0) {
        this.$store.commit("SET_LOADER", true);
        // Check payment validation for selected POs
        if (this.form.vendorId && this.selectedPurchaseOrders.length > 0) {
          const poIds = this.selectedPurchaseOrders.map(x => x.id);
          try {
            const res = await this.$store.dispatch("purchasePayment/checkPaymentByPoIds", poIds);
            if (res.data && res.data.length > 0) {
              const poNames = this.selectedPurchaseOrders
                .filter(x => res.data.includes(x.id))
                .map(x => x.name)
                .join(", ");
              this.$store.commit("SET_LOADER", false);
              this.$store.dispatch("toast", {
                type: "error",
                message: `PO ${poNames} sudah terbit payment purchase`,
              });
              return;
            }
          } catch (error) {
            this.$store.commit("SET_LOADER", false);
            this.$store.dispatch("toast", {
              type: "error",
              message: "Gagal mengecek payment PO",
            });
            return;
          }
        }

        this.form.formNumber = this.lastFormNumber;
        this.form.kasbonNumber = this.lastKasbonNumber;
        this.form.totalAmount = this.totalAmount;
        this.form.pphAmount = this.pphAmount;
        this.form.items = this.items;

        await this.$store
          .dispatch("generalKasbon/create", this.form)
          .then(() => this.$store.commit("SET_LOADER", false))
          .catch(() => {
            this.$store.dispatch("toast", {
              type: "error",
              message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
            });
            this.$store.commit("SET_LOADER", false);
          });
      } else {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Requirement is required",
        });
      }
    },
    deleteItem(index) {
      if (index > -1) {
        this.items.splice(index, 1);
        this.dialog = false;
        this.category = null;
      }
    },
    addItem(item) {
      if (this.index > -1) {
        this.items[this.index] = item;
      } else {
        this.items.push({ ...item });
      }
      this.category = null;
    },
    close() {
      this.dialog = false;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    clear() {
      this.items = [];
      this.form = Object.assign({}, this.defaultForm);
    },
    onClickRow(item) {
      this.item = item;
      this.index = this.items.indexOf(item);
      this.dialog = true;
    },
    onChangeCategory(val) {
      this.item = val;
      this.index = this.items.findIndex(x => x === val);
      this.dialog = true;
    },
    onChangeTemplate(val) {
      val.items.forEach(x => this.items.push({ ...x }));
    },
    async getListCategory() {
      const response = await this.$store.dispatch("generalKasbon/getListCategory");
      if (response.status === 200) {
        this.listCategory = response.data;
      }
    },
    async getListSite() {
      const response = await this.$store.dispatch("external/getSiteAll");
      if (response.status === 200) {
        this.listSite = response.data;
      }
    },
    async getTemplate() {
      await this.$store.dispatch("generalKasbon/getTemplates").then(response => {
        this.listTemplate = response.data;
      });
    },
    async onChangeVendor(val) {
      if (val) {
        this.form.vendorId = val.id;
        this.form.vendorName = val.supplier_name;
        this.selectedPurchaseOrders = [];
        this.form.purchaseOrderNumber = "";
        this.purchaseOrderVendor = null;
        const response = await this.$store.dispatch("external/getAllPurchaseOrders", val.id);
        if (response.status === 200) {
          this.purchaseOrders = response.data;
        }
      } else {
        this.form.vendorId = null;
        this.form.vendorName = "";
        this.purchaseOrders = [];
        this.selectedPurchaseOrders = [];
        this.form.purchaseOrderNumber = "";
        this.purchaseOrderVendor = null;
      }
    },
    addPurchaseOrder() {
      if (this.purchaseOrderVendor) {
        const exists = this.selectedPurchaseOrders.find(x => x.id === this.purchaseOrderVendor.id);
        if (exists) {
          this.$store.dispatch("toast", {
            type: "error",
            message: "PO sudah ditambahkan",
          });
        } else {
          this.selectedPurchaseOrders.push(this.purchaseOrderVendor);
          this.form.purchaseOrderNumber = this.selectedPurchaseOrders.map(x => x.name).join(",");
        }
        this.purchaseOrderVendor = null;
      }
    },
    removePurchaseOrder(index) {
      this.selectedPurchaseOrders.splice(index, 1);
      this.form.purchaseOrderNumber = this.selectedPurchaseOrders.map(x => x.name).join(",");
    },
    // eslint-disable-next-line no-unused-vars
    filterObjectPo(item, queryText, itemText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        (item.remark && item.remark.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1)
      );
    },
    async getVendors() {
      await this.$store.dispatch("external/getVendors");
    },
    async onChangeEmployee(val) {
      this.form.division = val.department.name;
      this.form.employeeId = val.hrId;
      this.form.name = val.name;
      this.form.bankAccountNumber = val.bankAccountNumber;
      this.form.ownerBank = val.name;
      this.getWos(val.hrId);
      // await this.$store.dispatch("generalKasbon/getListAccountNumber", val.id);
      this.isOverLimit = false;
      this.isWarning = false;
      this.allowanceData = null;
      try {
        const res = await this.$store.dispatch("employeeAllowance/getLimit", val.hrId);
        if (res && res.data) {
          this.allowanceData = res.data;
          if (res.data.overLimit) {
            this.isOverLimit = true;
            this.allowanceMessage =
              "Limit sudah habis, silahkan hubungi atasan untuk pengajuan limit baru.";
          } else if (res.data.warning) {
            this.isWarning = true;
            this.allowanceMessage = "Balance employee sudah melebihi batas aman.";
          } else {
            this.allowanceMessage = "Informasi sisa allowance employee.";
          }
          this.dialogAllowance = true;
        }
      } catch (e) {
        // Employee tanpa allowance record, skip
      }
    },
    // eslint-disable-next-line no-unused-vars
    filterObject(item, queryText, itemText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.accountName.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    async getWos(employeeId) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("wo/getByEmployeeId", employeeId)
        .then(response => {
          this.listWo = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    onChangeWo(val) {
      if (this.form.wos.findIndex(x => x.woId === val.id) > -1) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "WO sudah digunakan",
        });
      } else {
        this.form.wos.push({
          woId: val.id,
          sites: this.woSite(val.tasks),
          dates: this.woDate(val.tasks),
          poNumber: val.poNumber,
        });
      }
    },
    deleteWo(index) {
      this.form.wos.splice(index, 1);
    },
    woSite(tasks) {
      let siteName = [];
      if (tasks && tasks.length > 0) {
        tasks.map(x => {
          if (x.trips && x.trips.length > 0) {
            return x.trips.forEach(y => {
              siteName.push(y.siteName);
            });
          }
        });
        return siteName.filter((v, i, s) => s.indexOf(v) === i).join(",");
      }
      return "";
    },
    woDate(tasks) {
      if (tasks && tasks.length > 0) {
        tasks.map(x => x.date).join(",");
        return tasks
          .map(x => x.date)
          .filter((v, i, s) => s.indexOf(v) === i)
          .join(",");
      }
      return "";
    },
    // eslint-disable-next-line no-unused-vars
    filterObjectWo(item, queryText, itemText) {
      return (
        item.id.toString().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        this.woSite(item.tasks)
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        this.woDate(item.tasks)
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        (item.poNumber &&
          item.poNumber.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1)
      );
    },
    onChangeExternal(val) {
      if (val) {
        this.form.externalAccountNumber = {
          bankName: "",
          ownerBank: "",
          accountNumber: "",
          swiftCode: "",
        };
      } else {
        this.form.externalAccountNumber = null;
        this.bank = null;
      }
    },
    async getBankExternals() {
      await this.$store.dispatch("bank/getExternals").then(response => {
        this.banks = response.data;
      });
    },
    onChangeBank(val) {
      this.form.externalAccountNumber.bankName = val.name;
      this.form.externalAccountNumber.swiftCode = val.swiftCode;
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([
        await this.$store.dispatch("generalKasbon/getLastKasbonNumber"),
        await this.$store.dispatch("currency/getListCurrency"),
        await this.$store.dispatch("external/getEmployees"),
        await this.$store.dispatch("generalKasbon/getLastFormNumber"),
        this.getListCategory(),
        this.getTemplate(),
        this.getBankExternals(),
        this.getVendors(),
      ])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },

  mounted() {
    this.getInitialData();
    this.form = Object.assign({}, this.defaultForm);
  },
};
</script>

<style></style>
